import React from 'react'
import { View, Text } from 'dripsy'
import Skeleton from '@beatgig/design/components/skeleton'

type Props = {
  placeholder?: boolean
  children?: React.ReactNode
} & React.ComponentProps<typeof Text>

export default function DiscoverSectionArtistRowTitle(props: Props) {
  const { sx = {}, children, placeholder = false } = props

  return (
    <Text
      sx={{
        color: 'text',
        // fontWeight: ['800', null, '700'],
        fontWeight: '700',
        fontSize: [5, 6, 7],
        mx: 2,
        pl: [0, 5],
        ...sx,
      }}
    >
      {placeholder ? ' ' : children}
    </Text>
  )
}
